import React from 'react';
import { StyledResiliencyPolicyWrapper } from './styled';
import ResiliencyDashboard from '@components/precision/resiliency';
import { track } from '@utils';
import { NEW_RESILIENCY_DASHBOARD_PAGE_VIEWED } from '@utils/sensor/track';

const ResiliencyPage = () => {
  track({
    event: NEW_RESILIENCY_DASHBOARD_PAGE_VIEWED,
  });

  return (
    <StyledResiliencyPolicyWrapper>
      <ResiliencyDashboard />
    </StyledResiliencyPolicyWrapper>
  );
};

export default ResiliencyPage;
